import { ReactComponent as o } from "./icons/additional.svg.js";
import { ReactComponent as t } from "./icons/alert-error.svg.js";
import { ReactComponent as e } from "./icons/alert-success.svg.js";
import { ReactComponent as r } from "./icons/arrow-down.svg.js";
import { ReactComponent as m } from "./icons/arrow-left.svg.js";
import { ReactComponent as a } from "./icons/arrow-light-down.svg.js";
import { ReactComponent as n } from "./icons/arrow-light-left.svg.js";
import { ReactComponent as p } from "./icons/arrow-light-right.svg.js";
import { ReactComponent as i } from "./icons/arrow-light-up.svg.js";
import { ReactComponent as c } from "./icons/arrow-right.svg.js";
import { ReactComponent as s } from "./icons/arrow-up.svg.js";
import { ReactComponent as g } from "./icons/book.svg.js";
import { ReactComponent as f } from "./icons/calendar.svg.js";
import { ReactComponent as l } from "./icons/checkmark.svg.js";
import { ReactComponent as v } from "./icons/chevron-down.svg.js";
import { ReactComponent as C } from "./icons/chevron-left.svg.js";
import { ReactComponent as S } from "./icons/chevron-right.svg.js";
import { ReactComponent as R } from "./icons/chevron-up.svg.js";
import { ReactComponent as d } from "./icons/circle.svg.js";
import { ReactComponent as h } from "./icons/close.svg.js";
import { ReactComponent as w } from "./icons/color-indicator.svg.js";
import { ReactComponent as u } from "./icons/connected.svg.js";
import { ReactComponent as k } from "./icons/copy-link.svg.js";
import { ReactComponent as b } from "./icons/cross.svg.js";
import { ReactComponent as L } from "./icons/default-avatar.svg.js";
import { ReactComponent as A } from "./icons/diagnostics.svg.js";
import { ReactComponent as D } from "./icons/download.svg.js";
import { ReactComponent as M } from "./icons/dropdown.svg.js";
import { ReactComponent as P } from "./icons/dummy.svg.js";
import { ReactComponent as y } from "./icons/email.svg.js";
import { ReactComponent as x } from "./icons/external-link.svg.js";
import { ReactComponent as F } from "./icons/facebook.svg.js";
import { ReactComponent as I } from "./icons/fax.svg.js";
import { ReactComponent as U } from "./icons/file.svg.js";
import { ReactComponent as E } from "./icons/file-download.svg.js";
import { ReactComponent as q } from "./icons/filter.svg.js";
import { ReactComponent as B } from "./icons/globe.svg.js";
import { ReactComponent as G } from "./icons/globe-mobile.svg.js";
import { ReactComponent as T } from "./icons/google-cal.svg.js";
import { ReactComponent as O } from "./icons/info.svg.js";
import { ReactComponent as Y } from "./icons/instagram.svg.js";
import { ReactComponent as j } from "./icons/linkedin.svg.js";
import { ReactComponent as z } from "./icons/list.svg.js";
import { ReactComponent as H } from "./icons/loading.svg.js";
import { ReactComponent as J } from "./icons/location.svg.js";
import { ReactComponent as K } from "./icons/logo.svg.js";
import { ReactComponent as N } from "./icons/map.svg.js";
import { ReactComponent as Q } from "./icons/medicine.svg.js";
import { ReactComponent as V } from "./icons/minus.svg.js";
import { ReactComponent as W } from "./icons/mobile.svg.js";
import { ReactComponent as X } from "./icons/mobile-close.svg.js";
import { ReactComponent as Z } from "./icons/mobile-menu.svg.js";
import { ReactComponent as _ } from "./icons/mobile-search.svg.js";
import { ReactComponent as $ } from "./icons/molecular-item.svg.js";
import { ReactComponent as oo } from "./icons/outlook.svg.js";
import { ReactComponent as to } from "./icons/partnership.svg.js";
import { ReactComponent as eo } from "./icons/patient.svg.js";
import { ReactComponent as ro } from "./icons/pause.svg.js";
import { ReactComponent as mo } from "./icons/pause-bare.svg.js";
import { ReactComponent as ao } from "./icons/people.svg.js";
import { ReactComponent as no } from "./icons/phone.svg.js";
import { ReactComponent as po } from "./icons/play.svg.js";
import { ReactComponent as io } from "./icons/play-bare.svg.js";
import { ReactComponent as co } from "./icons/plus.svg.js";
import { ReactComponent as so } from "./icons/podcasts.svg.js";
import { ReactComponent as go } from "./icons/remove.svg.js";
import { ReactComponent as fo } from "./icons/search.svg.js";
import { ReactComponent as lo } from "./icons/search-mobile.svg.js";
import { ReactComponent as vo } from "./icons/series.svg.js";
import { ReactComponent as Co } from "./icons/sort-ascending.svg.js";
import { ReactComponent as So } from "./icons/sort-descending.svg.js";
import { ReactComponent as Ro } from "./icons/stock-down.svg.js";
import { ReactComponent as ho } from "./icons/stock-equal.svg.js";
import { ReactComponent as wo } from "./icons/stock-up.svg.js";
import { ReactComponent as uo } from "./icons/time.svg.js";
import { ReactComponent as ko } from "./icons/twitter.svg.js";
import { ReactComponent as bo } from "./icons/upload.svg.js";
import { ReactComponent as Lo } from "./icons/youtube.svg.js";
const Wt = {
  additional: o,
  "alert-error": t,
  "alert-success": e,
  "arrow-down": r,
  "arrow-left": m,
  "arrow-light-down": a,
  "arrow-light-left": n,
  "arrow-light-right": p,
  "arrow-light-up": i,
  "arrow-right": c,
  "arrow-up": s,
  book: g,
  calendar: f,
  checkmark: l,
  "chevron-down": v,
  "chevron-left": C,
  "chevron-right": S,
  "chevron-up": R,
  circle: d,
  close: h,
  "color-indicator": w,
  connected: u,
  "copy-link": k,
  cross: b,
  "default-avatar": L,
  diagnostics: A,
  download: D,
  dropdown: M,
  dummy: P,
  email: y,
  "external-link": x,
  facebook: F,
  fax: I,
  "file-download": E,
  file: U,
  filter: q,
  "globe-mobile": G,
  globe: B,
  "google-cal": T,
  info: O,
  instagram: Y,
  linkedin: j,
  list: z,
  loading: H,
  location: J,
  logo: K,
  map: N,
  medicine: Q,
  minus: V,
  "mobile-close": X,
  "mobile-menu": Z,
  "mobile-search": _,
  mobile: W,
  "molecular-item": $,
  outlook: oo,
  partnership: to,
  "pause-bare": mo,
  pause: ro,
  patient: eo,
  people: ao,
  phone: no,
  "play-bare": io,
  play: po,
  plus: co,
  podcasts: so,
  remove: go,
  "search-mobile": lo,
  search: fo,
  series: vo,
  "sort-ascending": Co,
  "sort-descending": So,
  "stock-down": Ro,
  "stock-equal": ho,
  "stock-up": wo,
  time: uo,
  twitter: ko,
  upload: bo,
  youtube: Lo
}, Xt = [
  "arrow-left",
  "arrow-light-left",
  "arrow-light-right",
  "arrow-right",
  "chevron-left",
  "chevron-right",
  "diagnostics",
  "external-link",
  "file-download",
  "file",
  "list",
  "stock-down",
  "stock-equal",
  "stock-up",
  "loading"
];
export {
  Xt as IconsRightToLeft,
  Wt as icons
};
